export * from "./exports";
import { unstable_batchedUpdates as batch } from "./utils/reactBatchedUpdates";
import { setBatch } from "./utils/batch";
setBatch(batch);
export { batch };
